<template>
  <div id="Colleges">
       
            <v-list class="pb-0 pt-0 white tileCard"  two-line>

             
                <v-list-item class="grey lighten-5 mt-3" @click="moreInfo(college)">
            
              
            
  
                    <v-list-item-content>
                        <v-list-item-title class="light-blue--text text--darken-4 subheading font-weight-medium" >{{college.college_name}}</v-list-item-title>
                      <v-list-item-subtitle class="mt-1" >
                        Degree
                        <span v-if="college.degree === 'In Progress'" >In Progress </span>
                        <span v-if="college.degree === 'Completed'" > Completed:  </span>
                        <span class="green--text">{{college.college_degree_awarded}}</span>
                      </v-list-item-subtitle>
                       <!-- <v-list-item-subtitle >Courses Taken:  
                        <span v-if="college.degree === 'In Progress'" class=" grey--text">0</span>
                        <span v-if="college.degree === 'Completed'" class="caption green--text">{{college.college_degree_awarded}} Completed</span>
                      </v-list-item-subtitle> -->
                     
                    
                
                    </v-list-item-content>
                
                  
                    <v-list-item-action class="mb-3">
                  
                    <v-btn class="mt-2" icon rounded :ripple="false" >
                      <v-icon color="grey">mdi-chevron-right</v-icon>
                      </v-btn>
  
                
  
                    </v-list-item-action>
            
            
                </v-list-item>
          
             
            
            </v-list>    

       
     
  </div>
</template>

<script>
  export default {
    props: ['college'],
    data() {
      return {
        show: false,
        alert: true,
      }
    },
    computed: {
      user() {
        return this.$store.getters.user
      },


    },
    methods: {
      moreInfo (college) {
        this.$router.push('/dashboard/mygrades/mycollege/' + college.id)
      }
    },
    watch: {

    }
  }
</script>

<style scoped>

#list {
  padding-left: 0px !important;
  padding-right: 0px !important;
  position: aboslute;
  
}
::-webkit-scrollbar { 
    display: none; 
}


.progress-circular {
  margin: 1rem;
  text-align: center;
}

.valueCard {
  text-align: center;
  background-color:white;
  margin:10px;

}

.titleBottom {
  color:#4296EC;

}

.titleBottomContainer {
  color:#4296EC;
  margin-top: 15px;
  padding-bottom: 15px;
}

.buttonContainer {
  display:flex;
  align-items:center;
  justify-content: center;
}

#nonScience {
  font-size: 14px;
}

.signupOrLoginContainer {
  display:flex;
  flex-direction: column;
  align-items:center;
  justify-content: center;
  margin-top: 30px;
}

.subtitle {
  color: rgb(85, 85, 85);
}

.text {
  font-size:20px;
  color: rgb(85, 85, 85);
  margin-top: 20px;
}

#titleContainer {
  display:flex;
  align-items:center;
  justify-content: space-between;
  width:330px;
}


.card {
    border-radius: 5px;

  }

#buttonShadow {
  box-shadow: 0 10px 30px -10px rgba(0,0,0,.19);
}

.tileCard {
  border-radius: 10px;
  box-shadow: 0 10px 30px -10px rgba(0,0,0,.19);
}

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Grades/Colleges.vue